import styled from 'styled-components';

export const StyledShipmentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  .shipment-header {
    .header-loading {
      height: 7.75rem;
    }

    .shipment-title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .shipment-status {
        display: flex;
        align-items: center;
        gap: 1rem;
      }
    }

    .Polaris-Text--root.Polaris-Text--headingSm.Polaris-Text--semibold,
    .Polaris-Text--root.Polaris-Text--headingMd.Polaris-Text--semibold {
      margin-block: 0.75rem;
    }
  }

  .shipment-items {
    .product-list {
      max-height: 30rem;
      overflow-y: auto;

      .product-loading {
        height: 8rem;
        padding: 1rem;
      }
    }
  }

  .shipment-subtotal {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    align-items: center;
    padding-top: 1rem;
  }
`;

export const ShipmentStatusStyled = styled.div<{ $background: string; $color: string }>`
  display: flex;
  align-items: center;
  gap: 12px;

  .icon {
    padding: 8px;
    border-radius: 50%;
    background: ${(props) => props.$background};
    svg {
      fill: ${(props) => props.$color};
    }
  }
`;

export const ShipmentUntrackedBannerStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .icon {
    padding: 8px;
    border-radius: 8px;
    background: #91d0ff;
    svg {
      fill: #002133;
    }
  }
`;

export const ShipmentUnfulfilledBannerStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: var(--p-color-bg-fill-info);
    flex-shrink: 0;

    svg {
      fill: #202223;
      width: 20px;
      height: 20px;
    }
  }
`;
